// #region import
import { getApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { LogMethod, BootstrapVariant } from '@/utils'
// #endregion

// #region store
export default {
  namespaced: true,
  // #region state
  state: {},
  // #endregion
  // #region getters
  getters: {},
  // #endregion
  // #region mutations
  mutations: {},
  // #endregion
  // #region actions
  actions: {
    /**
     * Initialize the Module.
     * @async
     */
    initializeModule() { },
  },
  // #endregion
  // #region modules
  modules: {},
  // #endregion
}
// #endregion
